import { Component, inject } from '@angular/core';
import { ScopeTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ScopeTypeCreateDto,
  ScopeTypeDto,
  ScopeTypeExcelDownloadDto,
  ScopeTypeUpdateDto,
} from '../proxy/controlling/dtos/scope-type';
import { SCOPETYPE_CONFIG, SCOPETYPE_FIELDS } from './scope-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-scope-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ScopeTypeService, ConfirmationService],
  templateUrl: './scope-type.html',
  styleUrl: './scope-type.scss',
})
export class ScopeType extends BaseCrudComponent<
  ScopeTypeDto,
  ScopeTypeCreateDto,
  ScopeTypeUpdateDto,
  ScopeTypeExcelDownloadDto
> {
  service = inject(ScopeTypeService);
  config = SCOPETYPE_CONFIG;
  fields = SCOPETYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ScopeTypeDto): ScopeTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ScopeType';
  }
}
